var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',_vm._g(_vm._b({class:`${_vm.bodyClass} ${_vm.textBodyClass}`,attrs:{"type":_vm.type,"border":_vm.border,"color":_vm.calculatedColor}},'v-alert',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }